"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var validateAmount = function validateAmount(amount, products) {
  var amountRange = products.reduce(function (amountRange, _ref) {
    var amountMin = _ref.amountMin,
      amountMax = _ref.amountMax;
    var current = {
      min: +amountMin.replace(/[$|,]/g, ''),
      minDisplay: amountMin,
      max: +amountMax.replace(/[$|,]/g, ''),
      maxDisplay: amountMax
    };
    if (!amountRange.min || current.min < amountRange.min) {
      amountRange.min = current.min;
      amountRange.minDisplay = current.minDisplay;
    }
    if (!amountRange.max || current.max > amountRange.max) {
      amountRange.max = current.max;
      amountRange.maxDisplay = current.maxDisplay;
    }
    return amountRange;
  }, {});
  return amount >= amountRange.min && amount <= amountRange.max ? '' : "Enter a valid amount between ".concat(amountRange.minDisplay, " and ").concat(amountRange.maxDisplay);
};
var _default = validateAmount;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/pf-payment-calculator/dist/client/components/scss/index.scss');